import React from 'react';
import { Button } from 'antd';
import './Footer.css'; 

const Footer = ({ onBack, onNext, nextDisabled = false, backLabel = "Back", nextLabel = "Next" }) => {
  return (
    <div className="bottom-navigation">
      <Button
        type="default"
        style={{
          marginRight: '10px',
          borderRadius: '20px',
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid black',
        }}
        onClick={onBack}
      >
        {backLabel}
      </Button>
      <Button
        type="primary"
        disabled={nextDisabled}
        style={{ borderRadius: '20px' }}
        onClick={onNext}
      >
        {nextLabel}
      </Button>
    </div>
  );
};

export default Footer;
